<template>
  <div
    class="search-box tw-flex tw-justify-center search-mobile tw-items-center"
  >
    <SearchIcon :size="15" color="#878787" />
    <input
      :value="modelValue"
      type="text"
      :placeholder="hintText"
      class="autoFocusNotify"
      @input="updateInput"
    />
  </div>
</template>

<script setup lang="ts">
import SearchIcon from "@/components/svgs/searchIcon.vue";
const emit = defineEmits(["update:modelValue"]);
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  hintText: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
});

const updateInput = (e: any) => {
  emit("update:modelValue", e.target.value);
};
</script>

<style scoped lang="scss">
.search-box {
  border: 1px solid var(--ui-rule, #eff0f1);
  border-radius: 6px;
  padding: 12px 15px 11px 15px;
  color: white;

  width: 300px;
  outline: none;
  background: white;
}

.search-box input {
  border: none;
  outline: none;
  width: 100%;
  margin-left: 9px;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

@media (min-width: 479px) {
  .search-mobile {
    flex: 1;
  }
}

input::placeholder {
  color: #b7b7b7;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>
